import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "mtop-20" }
const _hoisted_3 = { class: "row-bottom" }
const _hoisted_4 = { class: "mleft-02" }

import { ref, computed, onMounted, nextTick } from 'vue';
import { useI18n } from "vue-i18n";
import appuserapi from '@/api/appuserapi';
import { createReferenceSheetTitle } from '@/functions/resultSuggestion.js';
import SharedService from "@/services/SharedService";
import { useCurrentEntryStore } from '@/stores/currentEntry'
type RefSheetSelection = {
  id: string | number
  name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'createRefDocument',
  emits: ['afterReferenceDocumentCreation'],
  setup(__props, { emit: __emit }) {

const currentEntryStore = useCurrentEntryStore()

const { t } = useI18n();

const emits = __emit;

const focusRef = ref();
const searchContent = ref("");
const refSheetGroups = ref([]);
const selectedRefSheet = ref<RefSheetSelection | null>(null);
const isSearching = ref(false);
const newDocTitle = ref(currentEntryStore.currentDoc?.patientDocument.originalText || '');
const newDocTitleRef = ref();

async function initialize() {
  const allRefSheets = await appuserapi.allReferenceSheetsToDto();
  refSheetGroups.value = createRefSheetGroups(allRefSheets);
  focusRef.value?.innerRef?.focus();
}

function createRefSheetGroups(allRefSheets) {
  const arrangedList = allRefSheets.flatMap(refSheet => {
    const triggerArr = refSheet.triggers.split('\n');
    const title = triggerArr[0];
    return triggerArr.map(trigger => ({
      refSheet,
      title,
      trigger,
    }));
  });
  arrangedList.sort((a, b) => a.trigger.localeCompare(b.trigger));
  return arrangedList;
}

const filteredRefSheetGroups = computed(() => {
  const groups = refSheetGroups.value;
  const searchString = searchContent.value.trim().toLowerCase();
  if (searchString.length <= 1) return groups;
  return groups.filter(group => {
    return group.title.toLowerCase().startsWith(searchString) 
      || group.trigger.toLowerCase().startsWith(searchString);
  });
});

const showCreateOption = computed(() => {
  const searchString = searchContent.value.trim().toLowerCase();
  if (!searchString) return false;
  const hasExactMatch = refSheetGroups.value.some(group =>
    group.title.toLowerCase() === searchString ||
    group.trigger.toLowerCase() === searchString
  );
  return !hasExactMatch;
});

const showDocsAndCreate = computed(() => {
  return selectedRefSheet.value !== null && !isSearching.value;
});

const showSaveButton = computed(() => {
  return showDocsAndCreate.value && newDocTitle.value.trim() !== "";
});

async function onPillClose() {
  isSearching.value = true;
  searchContent.value = "";
  await nextTick();
  focusRef.value?.innerRef?.focus();
}

function onSearchBlur() {
  // If user bailed without picking anything and a previous selection exists, revert
  if (!searchContent.value.trim() && selectedRefSheet.value) {
    isSearching.value = false;
  }
}

async function setRefSheet(refSheet) {
  const refSheetId = refSheet.appUserResultReferenceId;
  const refSheetTitle = createReferenceSheetTitle(refSheet);
  selectedRefSheet.value = { id: refSheetId, name: refSheetTitle };
  isSearching.value = false;
  searchContent.value = "";
  await nextTick();
  newDocTitleRef.value?.innerRef?.focus();
}

async function createNewRefSheet() {
  const newTitle = searchContent.value.trim();
  if (!newTitle) return;
  const newRefSheet = await appuserapi.addRefSheet(newTitle);
  const refSheetTitle = createReferenceSheetTitle(newRefSheet);
  selectedRefSheet.value = { id: newRefSheet.appUserResultReferenceId, name: refSheetTitle };
  isSearching.value = false;
  searchContent.value = "";
  await nextTick();
  newDocTitleRef.value?.innerRef?.focus();
}

async function createReferenceDocument() {
  if (!selectedRefSheet.value) return;
  const title = newDocTitle.value.trim();
  if (!title) return;
  const patientDocumentId = currentEntryStore.currentDoc.patientDocument.patientDocumentId;
  const refSheetId = selectedRefSheet.value.id.toString();
  emits("afterReferenceDocumentCreation");
  await appuserapi.createReferenceDocument(refSheetId, patientDocumentId, title);
}

function onTitleEnter() {
  if (showSaveButton.value) {
    createReferenceDocument();
  }
}

onMounted(() => {
  initialize();
})

return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"28rem","height":"21rem"},
    class: "bg-modal",
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
  }, [
    (selectedRefSheet.value && !isSearching.value)
      ? (_openBlock(), _createBlock(_component_buttonGroup, {
          key: 0,
          styles: "pad-s border-m",
          class: "gap-04 psides-06 mleft-04 mtop-02",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onPillClose()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              icon: "bookOpen",
              styles: "main-m",
              class: "mtop-01"
            }),
            _createVNode(_component_text_item, {
              txt: selectedRefSheet.value.name,
              styles: "font-mBold main-m"
            }, null, 8, ["txt"]),
            _createElementVNode("img", {
              src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
              class: "mtop-03 mleft-02 img-grey-dark"
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('refSheet.selectRefSheet'),
            styles: "font-mBold",
            class: "mleft-02"
          }, null, 8, ["txt"]),
          _createVNode(_component_inputComboBox2, {
            ref_key: "focusRef",
            ref: focusRef,
            modelValue: searchContent.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchContent).value = $event)),
            onBlur: onSearchBlur,
            class: "mtop-02"
          }, {
            dropd: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRefSheetGroups.value, (refSheetGroup, index) => {
                return (_openBlock(), _createBlock(_component_list_group, {
                  key: index,
                  styles: "pad-s",
                  onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  onClick: ($event: any) => (setRefSheet(refSheetGroup.refSheet))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: refSheetGroup.trigger,
                      class: "mleft-06 col-width"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_svg_item, {
                      icon: "bookOpen",
                      styles: "main-l",
                      class: "mleft-10 mtop-01"
                    }),
                    _createVNode(_component_text_item, {
                      txt: refSheetGroup.title,
                      styles: "main-m",
                      class: "mleft-04 col-width"
                    }, null, 8, ["txt"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128)),
              (showCreateOption.value)
                ? (_openBlock(), _createBlock(_component_list_group, {
                    key: 0,
                    styles: "pad-s",
                    onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (createNewRefSheet()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('action.create'),
                        class: "mleft-06 col-width align-r"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_svg_item, {
                        icon: "book",
                        styles: "main-l",
                        class: "mleft-10 mtop-01"
                      }),
                      _createVNode(_component_text_item, {
                        txt: searchContent.value,
                        styles: "main-m",
                        class: "mleft-04 col-width"
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 64)),
    (showDocsAndCreate.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('refSheet.referenceDocument.newTitle'),
                  styles: "font-mBold"
                }, null, 8, ["txt"]),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('refSheet.referenceDocument.newTitleExample'),
                  styles: "main-l"
                }, null, 8, ["txt"])
              ]),
              (showSaveButton.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 0,
                    styles: "pad-s border-m",
                    class: "mleft-auto",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (createReferenceDocument()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('action.create'),
                        styles: "font-mBold",
                        class: "psides-04"
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_inputBox, { class: "w-full mtop-05" }, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                ref_key: "newDocTitleRef",
                ref: newDocTitleRef,
                modelValue: newDocTitle.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newDocTitle).value = $event)),
                placeholder: _unref(t)('common.title') + ' ...',
                style: {"width":"22rem"},
                onKeydown: _withKeys(_withModifiers(onTitleEnter, ["prevent"]), ["enter"])
              }, null, 8, ["modelValue", "placeholder", "onKeydown"])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})